export const palette = {
  Красный: '#ff0000',
  Синий: '#0000ff',
  Зеленый: '#00ff00',
  Желтый: 'yellow',
  Голубой: 'cyan',
  Серый: 'gray',
  Оранжевый: 'orange',
  Фиолетовый: 'purple',
  Черный: 'black',
  Белый: 'white',
  Коричневый: '#634940',
};
